module.exports = __webpack_public_path__ + "static/media/radu.42ec8617.jpg";